var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',_vm._b({attrs:{"append-to-body":"","title":_vm.title,"visible":_vm.currentVisible},on:{"update:visible":function($event){_vm.currentVisible=$event},"close":_vm.handlerClose}},'el-dialog',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }